module.exports = __webpack_public_path__ + "img/coffee.5b0abae8.svg";